import { getMetaSiteLink } from '../services/apis';
import { getIsBusinessFirst } from '../selectors/metaSite';
import { useInstallerContext } from '../context/InstallerContext';
import { getCreateSiteLink } from '../utils/postInstallation';
import { usePanorama } from '../context/PanoramaContext';
export const useHandleBusinessFirst = () => {
  const {
    httpClient,
    preInstallationData: {
      authorizationHeader
    }
  } = useInstallerContext();
  const {
    startTransaction,
    finishTransaction,
    errorMonitor
  } = usePanorama();
  return async requiredActions => {
    startTransaction('get-meta-site-for-biz-first');
    try {
      const metaSite = await httpClient.get(getMetaSiteLink(), {
        headers: {
          authorization: authorizationHeader
        }
      });
      const isBusinessFirst = getIsBusinessFirst(metaSite == null ? void 0 : metaSite.data);
      return isBusinessFirst && getCreateSiteLink(requiredActions) || '';
    } catch (e) {
      var _errorMonitor;
      (_errorMonitor = errorMonitor({
        source: 'get-meta-site-for-biz-first'
      })) == null || _errorMonitor.reportError(e);
      return;
    } finally {
      finishTransaction('get-meta-site-for-biz-first');
    }
  };
};
//# sourceMappingURL=useHandleBusinessFirst.js.map